var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20036 1.42566L4.45036 0.0623269C4.32449 0.0163122 4.18937 0.00136642 4.05649 0.0187599C3.9236 0.0361533 3.79688 0.0853718 3.68709 0.162232C3.5773 0.239093 3.48769 0.341323 3.42587 0.460235C3.36406 0.579147 3.33187 0.711224 3.33203 0.845244V3.39899C3.07989 3.24877 2.79219 3.16864 2.4987 3.16691C1.57953 3.16691 0.832031 3.91441 0.832031 4.83358C0.832031 5.75274 1.57953 6.50024 2.4987 6.50024C3.41786 6.50024 4.16536 5.75274 4.16536 4.83358V0.845244L7.91536 2.20858V5.06524C7.66311 4.91533 7.37546 4.83536 7.08203 4.83358C6.16286 4.83358 5.41536 5.58108 5.41536 6.50024C5.41536 7.41941 6.16286 8.16691 7.08203 8.16691C8.0012 8.16691 8.7487 7.41941 8.7487 6.50024V2.20858C8.7487 1.85941 8.52828 1.54441 8.20036 1.42566ZM2.4987 5.66691C2.03911 5.66691 1.66536 5.29316 1.66536 4.83358C1.66536 4.37399 2.03911 4.00024 2.4987 4.00024C2.95828 4.00024 3.33203 4.37399 3.33203 4.83358C3.33203 5.29316 2.95828 5.66691 2.4987 5.66691ZM7.08203 7.33358C6.62245 7.33358 6.2487 6.95983 6.2487 6.50024C6.2487 6.04066 6.62245 5.66691 7.08203 5.66691C7.54161 5.66691 7.91536 6.04066 7.91536 6.50024C7.91536 6.95983 7.54161 7.33358 7.08203 7.33358Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxMusic);
export default __webpack_public_path__ + "static/media/bx-music.6f1e8ea1c3cba03f1acdb7dbcab5398d.svg";
export { ForwardRef as ReactComponent };